<template>
<footer class="w-full bg-gradient-to-b from-white to-site-offwhite relative overflow-hidden font-poppins">
  <!-- Subtle texture overlay -->
  <div class="absolute inset-0 opacity-5" style="background-image: url('data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23D9A68C\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v6h6v-6h-6zm6 6v6h-6v-6h6zm-6-6v-6h6v6h-6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"></div>
  
  <!-- Top separator with gradient -->
  <div class="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D2919A]/20 to-transparent"></div>
  
  <div class="container mx-auto px-4 md:px-8 lg:px-16 max-w-[1600px] py-12 relative z-10">
    <!-- Main Footer Content -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12">
      <!-- Site Info Column -->
      <div>
        <h3 class="text-xl font-bold text-[#333333] mb-4 inline-block relative">
          Josh Terzi
          <span class="absolute -bottom-1 left-0 w-12 h-[2px] bg-gradient-to-r from-[#D2919A] to-[#D2919A]/70"></span>
        </h3>
        <p class="text-[#333333] mt-4 leading-relaxed">
          Counsellor based in Dorset, offering in-person, online, and telephone therapy sessions.
        </p>
        <div class="mt-4 flex space-x-3">
          <a href="#" class="footer-social-link" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
            </svg>
          </a>
          <a href="#" class="footer-social-link" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          <a href="#" class="footer-social-link" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
            </svg>
          </a>
        </div>
      </div>
      
      <!-- Quick Links Column -->
      <div>
        <h3 class="text-xl font-bold text-[#333333] mb-4 inline-block relative">
          Quick Links
          <span class="absolute -bottom-1 left-0 w-12 h-[2px] bg-gradient-to-r from-[#D2919A] to-[#D2919A]/70"></span>
        </h3>
        <nav class="flex flex-col space-y-2 mt-4">
          <a href="#what-i-offer" @click.prevent="scrollToSection('what-i-offer')" class="footer-link">What I Offer</a>
          <a href="#about" @click.prevent="scrollToSection('about')" class="footer-link">About</a>
          <a href="#qualifications-training" @click.prevent="scrollToSection('qualifications-training')" class="footer-link">Qualifications</a>
          <a href="#sessions" @click.prevent="scrollToSection('sessions')" class="footer-link">Sessions</a>
          <a href="#therapy-room" @click.prevent="scrollToSection('therapy-room')" class="footer-link">Therapy Room</a>
          <a href="#contact" @click.prevent="scrollToSection('contact')" class="footer-link">Contact</a>
        </nav>
      </div>
      
      <!-- Hours & Location Column -->
    </div>
    
    <!-- Bottom Bar with Credentials and Copyright -->
    <div class="pt-6 border-t border-site-border/30 text-center md:flex md:justify-between md:items-center">
      <div class="mb-4 md:mb-0">
        <span class="text-[#333333] text-sm">
          &copy; {{ new Date().getFullYear() }} Josh Terzi. All rights reserved.
        </span>
      </div>
      
      <div class="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2">
        <a href="#" class="text-[#333333] text-sm hover:text-[#D2919A] transition-colors duration-300">Privacy Policy</a>
        <a href="#" class="text-[#333333] text-sm hover:text-[#D2919A] transition-colors duration-300">Terms of Service</a>
        <span class="text-[#333333] text-sm">MBACP Registered</span>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'FooterSection',
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
/* Footer social links */
.footer-social-link {
  @apply w-9 h-9 rounded-full bg-white flex items-center justify-center text-[#333333]/70 border border-[#D2919A]/30 transition-all duration-300;
}

.footer-social-link:hover {
  @apply text-[#D2919A] bg-[#D2919A]/5 border-[#D2919A]/40 transform -translate-y-1 shadow-sm;
}

/* Footer links */
.footer-link {
  @apply text-[#333333] hover:text-[#D2919A] transition-colors duration-300 relative pl-3;
}

.footer-link::before {
  content: '';
  @apply absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-[#D2919A]/40;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.footer-link:hover::before {
  @apply bg-[#D2919A] transform scale-125;
}
</style>